<template>
  <div class="container">
    <div v-if="payItem.amount">
      <div class="detail">
        <div class="detail-label">订单号：</div>
        <div class="detail-text">{{ payItem.orderNo }}</div>
      </div>
      <div class="detail">
        <div class="detail-label">订单名称：</div>
        <div class="detail-text" v-if="payItem.doctorName">
          {{ payItem.visitDate }}
          {{
            payItem.visitTime == '01'
              ? '白天'
              : payItem.visitTime == '02'
              ? '晚上'
              : payItem.visitTime == '04'
              ? '上午'
              : payItem.visitTime == '05'
              ? '下午'
              : payItem.visitTime == '06'
              ? '全天'
              : payItem.visitTime == '07'
              ? '复诊'
              : payItem.visitTime == '08'
              ? '复诊1'
              : ''
          }}
          {{ payItem.sectionName || '' }}
          {{ payItem.doctorName || '' }}
        </div>
        <div v-else class="detail-text">处方缴费</div>
      </div>
      <div class="detail">
        <div class="detail-label">应付金额：</div>
        <div class="detail-text">{{ payItem.amount }}</div>
      </div>
      <div class="pay-num">
        <div class="pay-num-label">需要支付</div>
        <div class="pay-num-text">￥{{ payItem.amount }}</div>
      </div>
      <div class="pay-box">
        <div
          class="wechat"
          @click="selectType('wechat')"
          v-if="payType == 'wechat'"
        >
          <div class="wechat-label">
            <van-icon
              name="wechat"
              size="30"
              color="rgb(80,182,116)"
              style="margin-right: 10px"
            />
            微信支付
          </div>
          <div class="wechat-text">
            <van-icon
              v-if="payType == 'wechat'"
              name="checked"
              size="28"
              color="rgb(80,182,116)"
            />
          </div>
        </div>
        <div class="aliPay" @click="selectType('aliPay')" v-else>
          <div class="aliPay-label">
            <van-icon
              name="alipay"
              size="30"
              color="rgb(22,119,254)"
              style="margin-right: 10px"
            />
            支付宝支付
          </div>
          <div class="aliPay-text">
            <van-icon
              v-if="payType == 'aliPay'"
              name="checked"
              size="28"
              color="rgb(80,182,116)"
            />
          </div>
        </div>
      </div>
      <div class="btn-box">
        <van-button round type="info" size="large" @click="pay">
          确认支付
        </van-button>
      </div>
    </div>
    <div v-else>
      <!-- <div class="detail">
        <div class="detail-label">订单号：</div>
        <div class="detail-text">{{ payItem.orderNo }}</div>
      </div> -->
      <div class="detail">
        <div class="detail-label">订单名称：</div>
        <div class="detail-text">挂号缴费</div>
      </div>
      <div class="detail">
        <div class="detail-label">应付金额：</div>
        <div class="detail-text">{{ payItem.FeeSumamt }}</div>
      </div>
      <div class="pay-num">
        <div class="pay-num-label">需要支付</div>
        <div class="pay-num-text">￥{{ payItem.FeeSumamt }}</div>
      </div>
      <div class="pay-box">
        <div
          class="wechat"
          @click="selectType('wechat')"
          v-if="payType == 'wechat'"
        >
          <div class="wechat-label">
            <van-icon
              name="wechat"
              size="30"
              color="rgb(80,182,116)"
              style="margin-right: 10px"
            />
            微信支付
          </div>
          <div class="wechat-text">
            <van-icon
              v-if="payType == 'wechat'"
              name="checked"
              size="28"
              color="rgb(80,182,116)"
            />
          </div>
        </div>
        <div class="aliPay" @click="selectType('aliPay')" v-else>
          <div class="aliPay-label">
            <van-icon
              name="alipay"
              size="30"
              color="rgb(22,119,254)"
              style="margin-right: 10px"
            />
            支付宝支付
          </div>
          <div class="aliPay-text">
            <van-icon
              v-if="payType == 'aliPay'"
              name="checked"
              size="28"
              color="rgb(22,119,254)"
            />
          </div>
        </div>
      </div>
      <div class="btn-box">
        <van-button round type="info" size="large" @click="pay">
          确认支付
        </van-button>
      </div>
    </div>
    <!-- <van-empty v-if="!payItem" image="error" description="参数错误" /> -->
  </div>
</template>

<script>
import { getPayment, getAliPayForm } from '@/api/api'
import payResultVue from './payResult.vue'
import type from '../../utils/environment'
import { Dialog, Toast } from 'vant'
import '@/utils/ap.js'
export default {
  name: 'goPay',
  data() {
    return {
      payType: 'aliPay', // 浏览器支持支付宝，默认支付宝
      payItem: {},
      payMap: {}
    }
  },
  created() {},
  mounted() {
    var ua = window.navigator.userAgent
    //判断是不是微信
    if (type) {
      this.payType = 'wechat'
    } else {
      this.payType = 'aliPay'
    }
    // this.payItem = this.$route.params.orderNo ? this.$route.params : null
    this.payItem = this.$route.params
    if (this.payItem) Toast('请在十分钟内完成支付！')
  },
  watch: {},
  methods: {
    selectType(value) {
      this.payType = value
    },
    pay() {
      let thix = this
      this.$loading.show()
      if (this.payType == 'aliPay') {
        getAliPayForm(this.$route.params.id).then(res => {
          var formHtml = res.data
          // 移除内联的<script>标签，因为我们将手动提交表单
          formHtml = formHtml.replace(/<script>.*<\/script>/g, '')

          // 创建一个容器来放置表单
          var container = document.createElement('div')
          container.style.display = 'none' // 初始时隐藏容器，以便我们可以先添加表单再显示
          document.body.appendChild(container)

          // 将表单字符串转换为DOM元素并添加到容器中
          container.innerHTML = formHtml

          // 显示容器（这一步是可选的，取决于您是否想要先显示表单再提交）
          container.style.display = 'block' // 如果您想要看到表单，可以取消注释这一行

          // 手动提交表单
          document.forms['punchout_form'].submit() // 使用表单的名称来提交，确保名称与接收到的表单中的名称相匹配
          // const div = document.createElement('div')
          // div.innerHTML = res.data //此处form就是后台返回接收到的数据
          // document.body.appendChild(div)
          // // document.punchout_form.submit()
          // document.forms[0].acceptCharset = 'utf-8'
          // var queryParam = ''
          // Array.prototype.slice
          //   .call(document.querySelectorAll('input[type=hidden]'))
          //   .forEach(function(ele) {
          //     queryParam += '&' + ele.name + '=' + encodeURIComponent(ele.value)
          //   })
          // var gotoUrl =
          //   document.querySelector('form').getAttribute('action') +
          //   '&' +
          //   queryParam
          // _AP.pay(gotoUrl)
        })
      } else {
        console.log(this.$route.params.id)
        getPayment(this.$route.params.id).then(res => {
          // this.$router.push('payResult')
          this.$loading.hide()
          if (res.msg == 'fail') {
            Toast.fail(res.data)
            return
          }
          this.payMap = JSON.parse(res.data)
          if (typeof WeixinJSBridge == 'undefined') {
            if (document.addEventListener) {
              document.addEventListener(
                'WeixinJSBridgeReady',
                this.onBridgeReady(this.payItem.preType || 0),
                false
              )
            } else if (document.attachEvent) {
              document.attachEvent(
                'WeixinJSBridgeReady',
                this.onBridgeReady(this.payItem.preType || 0)
              )
              document.attachEvent(
                'onWeixinJSBridgeReady',
                this.onBridgeReady(this.payItem.preType || 0)
              )
            }
          } else {
            this.onBridgeReady(this.payItem.preType || 0)
          }
        })
      }
    },
    returnAmount(am) {
      return Number(am) / 100
    },
    onBridgeReady(i) {
      let thix = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: this.payMap.appId, //公众号名称，由商户传入
          timeStamp: this.payMap.timeStamp + '', //时间戳，自1970年以来的秒数
          nonceStr: this.payMap.nonceStr, //随机串
          package: this.payMap.package,
          signType: 'MD5', //微信签名方式：
          paySign: this.payMap.paySign //微信签名
        },
        function(res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            thix.$loading.hide()
            window.location.replace(
              window.location.protocol +
                '//' +
                window.location.host +
                '/#/payResult?status=1&preType=' +
                i
            )
          } else {
            thix.$loading.hide()
            window.location.replace(
              window.location.protocol +
                '//' +
                window.location.host +
                '/#/payResult?status=0&preType=' +
                i
            )
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  background: rgb(242, 248, 253);
}

.detail {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 34px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);

  &-label {
    color: #666;
    display: flex;
    align-items: center;
    font-size: 18px;
  }

  &-text {
    font-size: 18px;
  }
}

.pay-num {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  background: #fff;
  padding: 0 15px;
  border-bottom: 1px solid rgb(234, 234, 234);

  &-label {
    display: flex;
    align-items: center;
    font-size: 18px;
  }

  &-text {
    font-size: 18px;
    color: rgb(237, 125, 84);
  }
}

.pay-box {
  width: 100%;
  background: #fff;

  .wechat {
    width: 100%;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;

    &-label {
      display: flex;
      align-items: center;
      height: 50px;
      font-size: 18px;
    }

    &-text {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: rgb(237, 125, 84);
    }
  }

  .aliPay {
    width: 100%;
    padding: 0 15px;
    display: flex;
    justify-content: space-between;

    &-label {
      display: flex;
      align-items: center;
      height: 50px;
      font-size: 18px;
    }

    &-text {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: rgb(237, 125, 84);
    }
  }
}

.btn-box {
  width: 100%;
  padding: 0 15px;
  padding-top: 15px;
}
.btn-box button {
  height: 48px;
  font-size: 18px;
}
</style>
